
import { Navigate, Outlet } from "react-router-dom";
import { useSettings } from "@/providers/SettingsProvider";

interface DevModeProtectedRouteProps {
  children?: React.ReactNode;
}

export const DevModeProtectedRoute = ({ children }: DevModeProtectedRouteProps) => {
  const { devMode } = useSettings();

  if (!devMode) {
    return <Navigate to="/" replace />;
  }

  return children ? <>{children}</> : <Outlet />;
};
